export default __webpack_public_path__ + "static/media/img_10.0b3125dc.jpg";